var _excluded = ["beds", "propertyType"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import Geohash from 'latlon-geohash';
import { ListingBadges, LocalityType, PropertyFeature, PropertyStatus, PropertyType, RentalType, SaleMethod, getPrimaryPropertyTypesForListingType, getPropertyFeatureForType, getPropertyStatusForType } from '@domain-group/fe-allhomes-library/lib/node';
import defaults from '../enums/defaults';
import FilterType, { filterTypesForListingType } from '../enums/filter-type';
import ListedDateType from '../enums/listed-date-type';
import { resolveLocality } from '../locality/locality-resolver';
import { isDefined, values as objectValues, arrayUrlValues, urlValue, isA, mergeLocalities, toLocality } from '../utils';
import Range from './range';
import MultiValueFilter from './multi-value-filter';
/* eslint-disable id-length */

var _mapValues = mapValues(LocalityType, each => each.type),
  DIVISION = _mapValues.DIVISION,
  REGION = _mapValues.REGION,
  POSTCODE = _mapValues.POSTCODE,
  STREET = _mapValues.STREET,
  DISTRICT = _mapValues.DISTRICT,
  SCHOOL = _mapValues.SCHOOL;
var slugsOrIdsOf = array => array.map(each => _objectSpread({
  type: each.type
}, isEmpty(each.slug) ? {
  id: each.id
} : {
  slug: each.slug
}));
var isRangeEmpty = range => !(range && (isDefined(range.min) || isDefined(range.max)));
var rangeUrlValues = (label, value) => isRangeEmpty(value) ? null : {
  [label.toLowerCase()]: value.min === value.max ? "".concat(value.min) : "".concat(value.min || '', "-").concat(value.max || '')
};
var rangeUrlValuesForAvailability = (label, value) => {
  if (isRangeEmpty(value)) {
    return null;
  }
  if (isDefined(value.max) && !isDefined(value.min)) {
    return {
      [label]: "-".concat(value.max)
    };
  }
  return {
    [label]: "".concat(value.min)
  };
};
var localityUrlValues = function localityUrlValues(label) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arrayUrlValues(label, values.map(value => value.slug || value.id).sort());
};
var localityResolver = function localityResolver(localityMap) {
  var withoutMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return values => values.map(each => resolveLocality(each.type, each.id || each.slug, localityMap) || each).filter(each => !withoutMissing || each.name);
};
var isShortDate = date => /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/.test(date);
var validateListedDate = listedDate => {
  if (!listedDate || !listedDate.type) {
    return null;
  }
  var upperCaseType = listedDate.type.toUpperCase();
  if (!Object.keys(ListedDateType).includes(upperCaseType)) {
    return null;
  }
  if (upperCaseType === ListedDateType.SPECIFIC_DATE.name) {
    return isShortDate(listedDate.date) ? {
      type: upperCaseType,
      date: listedDate.date
    } : null;
  }
  return {
    type: upperCaseType
  };
};
var pointToHash = point => Geohash.encode(point.lat, point.lon, 12);
var hashToPoint = hash => Geohash.decode(hash);
var boundsUrlValues = bounds => bounds && {
  bounds: "".concat(pointToHash(bounds.from), ",").concat(pointToHash(bounds.to))
};
var getAvailableListingFeatures = listingType => getPropertyFeatureForType(listingType).map(item => item.name).map(key => PropertyFeature[key]);
var buildRange = (value, string) => value ? new Range(value, string) : null;
var parseBounds = hashList => {
  if (!hashList) {
    return null;
  }
  var _hashList$split = hashList.split(','),
    _hashList$split2 = _slicedToArray(_hashList$split, 2),
    from = _hashList$split2[0],
    to = _hashList$split2[1];
  return {
    from: hashToPoint(from),
    to: hashToPoint(to)
  };
};
class Filters {
  constructor(listingType, valuesParam) {
    var values = Filters.valuesOf(valuesParam);
    this.listingType = listingType;
    this.availableFilters = filterTypesForListingType(this.listingType);
    this.setFilter(FilterType.price, () => buildRange(values.price));
    this.setFilter(FilterType.beds, () => buildRange(values.beds));
    this.setFilter(FilterType.baths, () => buildRange(values.baths));
    this.setFilter(FilterType.parking, () => buildRange(values.parking));
    this.setFilter(FilterType.floorArea, () => buildRange(values.floorArea));
    this.setFilter(FilterType.blockSize, () => buildRange(values.blockSize));
    this.setFilter(FilterType.availability, () => buildRange(values.availability, true));
    this.setFilter(FilterType.onlyWithPrice, () => values.onlyWithPrice ? true : null);
    this.setFilter(FilterType.onlyWithEvents, () => values.onlyWithEvents ? true : null);
    this.setFilter(FilterType.propertyTypes, () => new MultiValueFilter(getPrimaryPropertyTypesForListingType(listingType), values.propertyTypes));
    this.setFilter(FilterType.propertyStatus, () => new MultiValueFilter(getPropertyStatusForType(listingType), values.propertyStatus, defaults.PROPERTY_STATUS[listingType]));
    this.setFilter(FilterType.saleMethods, () => new MultiValueFilter(objectValues(SaleMethod), values.saleMethods, defaults.SALE_METHOD));
    this.setFilter(FilterType.listingFeatures, () => new MultiValueFilter(getAvailableListingFeatures(listingType), values.listingFeatures));
    this.setFilter(FilterType.listedPropertyTypes, () => new MultiValueFilter(objectValues(RentalType), values.listedPropertyTypes, defaults.RENTAL_TYPE));
    this.setFilter(FilterType.badges, () => new MultiValueFilter(objectValues(ListingBadges), values.badges));
    this.setFilter(FilterType.listedDate, () => validateListedDate(values.listedDate));
    this.setFilter(FilterType.keywords, () => values.keywords || null);
    this.bounds = values.bounds || null;
    this.localities = [...(values.localities || [])];
    this.isLocationEmpty = this.isLocationEmpty.bind(this);
  }
  cloneWith() {
    for (var _len = arguments.length, newValues = new Array(_len), _key = 0; _key < _len; _key++) {
      newValues[_key] = arguments[_key];
    }
    return new Filters(this.listingType, Object.assign({}, this.getValues(), ...newValues));
  }
  cloneWithLocalities(localities) {
    return this.cloneWith({
      bounds: undefined,
      localities: [...(localities || [])]
    });
  }
  setFilter(filter, valueFunc) {
    if (this.availableFilters.includes(filter.name)) {
      this[filter.name] = valueFunc();
    }
  }

  /* eslint-disable id-length */
  getLocalities() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return this.bounds ? [] : this.localities.filter(each => !type || each.type === type);
  }
  getBounds() {
    return this.bounds;
  }
  getSingleLocality() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var localities = this.getLocalities(type) || [];
    return localities.length === 1 ? localities[0] : undefined;
  }
  resolveLocalities(localityMap, removeMissing) {
    var resolved = localityResolver(localityMap, removeMissing);
    this.localities = resolved(this.localities);
  }
  isLocationEmpty() {
    return isEmpty(this.localities) && isEmpty(this.getBounds());
  }
  isSold() {
    var _this$propertyStatus;
    return Boolean((_this$propertyStatus = this.propertyStatus) === null || _this$propertyStatus === void 0 ? void 0 : _this$propertyStatus.hasOnlyValue(PropertyStatus.SOLD.name));
  }
  isRented() {
    var _this$propertyStatus2;
    return Boolean((_this$propertyStatus2 = this.propertyStatus) === null || _this$propertyStatus2 === void 0 ? void 0 : _this$propertyStatus2.hasOnlyValue(PropertyStatus.RENTED.name));
  }
  isDefault() {}
  available() {
    return this.availableFilters;
  }
  getFilterValue(filter) {
    var value = this[filter];
    if (!value) {
      return null;
    }
    if (typeof value.getValues === 'function') {
      return value.getValues();
    }
    return value;
  }
  getUrlFilterValue(filter) {
    var slug = FilterType[filter].urlSlug;
    var value = this[filter];
    if (!value) {
      return null;
    }
    if (typeof value.toUrlParameter === 'function') {
      return value.toUrlParameter(slug);
    }
    if (Range.isInstance(value)) {
      return filter === FilterType.availability.name ? rangeUrlValuesForAvailability(slug, value) : rangeUrlValues(slug, value);
    }
    return urlValue(slug, value);
  }
  getValues() {
    var values = {
      localities: this.localities,
      bounds: this.bounds
    };
    return this.availableFilters.reduce((result, filter) => _objectSpread(_objectSpread({}, result), {}, {
      [filter]: this.getFilterValue(filter)
    }), values);
  }
  getLocalityUrlParameters() {
    var localities = this.getLocalities();

    // If localities only contains the default localities, in any order, then we'll just return an empty array
    if (localities.length === defaults.LOCALITIES.length && defaults.LOCALITIES.every(_ref => {
      var id = _ref.id,
        type = _ref.type,
        slug = _ref.slug;
      return localities.find(dflt => dflt.slug === slug || dflt.id === id && dflt.type === type);
    })) {
      return [];
    }
    return [localityUrlValues('region', this.getLocalities(REGION)), localityUrlValues('district', this.getLocalities(DISTRICT)), localityUrlValues('suburb', this.getLocalities(DIVISION)), localityUrlValues('street', this.getLocalities(STREET)), localityUrlValues('postcode', this.getLocalities(POSTCODE)), localityUrlValues('school', this.getLocalities(SCHOOL))];
  }
  getFilterUrlParameters() {
    return this.availableFilters.map(filter => this.getUrlFilterValue(filter));
  }
  toUrlParameters() {
    return [...this.getLocalityUrlParameters(), boundsUrlValues(this.getBounds()), ...this.getFilterUrlParameters()].filter(each => each && objectValues(each)[0] != null);
  }
  getLocation() {
    return _objectSpread({}, isEmpty(this.getBounds()) ? !isEmpty(this.localities) && {
      localities: slugsOrIdsOf(this.localities)
    } : {
      bounds: this.getBounds()
    });
  }
  toQueryObject() {
    var queryObject = _objectSpread({}, this.getLocation());
    return this.availableFilters.reduce((result, filter) => {
      var value = this[filter];
      if (MultiValueFilter.isInstance(value)) {
        return value.isDefault() ? result : _objectSpread(_objectSpread({}, result), {}, {
          [filter]: value.selected
        });
      }
      if (typeof value === 'boolean') {
        return value ? _objectSpread(_objectSpread({}, result), {}, {
          [filter]: value
        }) : result;
      }

      // Don't output empty values, including Range objects with no defined limit
      return Range.isInstance(value) && isRangeEmpty(value) || isEmpty(value) ? result : _objectSpread(_objectSpread({}, result), {}, {
        [filter]: value
      });
    }, queryObject);
  }
  isFilters() {
    return true;
  }
}
Filters.isInstance = value => isA(value, 'Filters');
Filters.valuesOf = obj => Filters.isInstance(obj) ? obj.getValues() : obj || {};
var locationFromQueryObject = function locationFromQueryObject(divisionId) {
  var localities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return [...(divisionId ? [toLocality(DIVISION, divisionId)] : []), ...localities.filter(each => !(divisionId && each.type === DIVISION && each.id === divisionId))];
};
var asLocalityArray = (stringList, type) => stringList ? stringList.split(',').filter(each => each).map(each => toLocality(type, each)) : [];
var asArray = string => string ? string.split(',').map(each => each.trim()) : [];
var parseRange = string => {
  if (!string) {
    return null;
  }
  var values = string.split('-').map(each => parseInt(each, 10));
  return [values[0], values.length > 1 ? values[1] : values[0]];
};
var parseSlugs = (object, string) => string != null && asArray(string).map(slug => objectValues(object).find(each => (each.urlSlug || each.name) === slug)).filter(each => each).map(each => each.name);
var parseAvailability = availability => {
  if (!availability) {
    return null;
  }
  var date = availability;
  var isTo = availability.indexOf('-') === 0;
  date = isTo ? date.substr(1) : date;
  // make sure the provided date matches YYYY-MM-DD format
  if (isShortDate(date)) {
    return isTo ? [null, date] : [date, null];
  }
  return null;
};
var locationFromUrlParameters = (queryParameters, _ref2) => {
  var divisionName = _ref2.divisionName,
    postcode = _ref2.postcode,
    listingState = _ref2.listingState;
  var suburbs = divisionName ? "".concat(divisionName, "-").concat(listingState, "-").concat(postcode, ",").concat(queryParameters.suburb || '') : queryParameters.suburb;
  var localities = mergeLocalities([...asLocalityArray(queryParameters.region, REGION), ...asLocalityArray(queryParameters.district, DISTRICT), ...asLocalityArray(suburbs, DIVISION), ...asLocalityArray(queryParameters.postcode, POSTCODE), ...asLocalityArray(queryParameters.street, STREET), ...asLocalityArray(queryParameters.school, SCHOOL)]);
  return localities.length ? localities : defaults.LOCALITIES;
};

/* eslint-disable id-length */
Filters.fromUrlParameters = function (listingType) {
  var q = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var FiltersClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Filters;
  var beds = _ref3.beds,
    propertyType = _ref3.propertyType,
    p = _objectWithoutProperties(_ref3, _excluded);
  return new FiltersClass(listingType, {
    listedDate: q.listeddate,
    propertyTypes: parseSlugs(PropertyType, q.propertytypes || propertyType),
    onlyWithPrice: q.withprice,
    price: parseRange(q.price),
    beds: parseRange(q.beds || beds),
    baths: parseRange(q.baths),
    parking: parseRange(q.parking),
    floorArea: parseRange(q.floorarea),
    blockSize: parseRange(q.blocksize),
    keywords: q.keywords,
    propertyStatus: p.listingType === 'sold' ? [...new Set([PropertyStatus.SOLD.name, ...(parseSlugs(PropertyStatus, q.status) || [])])] : parseSlugs(PropertyStatus, q.status),
    saleMethods: parseSlugs(SaleMethod, q.methods),
    listedPropertyTypes: parseSlugs(RentalType, q.listingtypes),
    availability: parseAvailability(q.availability),
    listingFeatures: parseSlugs(PropertyFeature, q.listingfeatures),
    badges: parseSlugs(ListingBadges, q.badges),
    onlyWithEvents: q.withevents,
    localities: locationFromUrlParameters(q, p),
    bounds: parseBounds(q.bounds)
  });
};
/* eslint-enable id-length */

Filters.fromQueryObject = function (listingType) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$filters = _ref4.filters,
    filters = _ref4$filters === void 0 ? {} : _ref4$filters,
    divisionId = _ref4.divisionId;
  var FiltersClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Filters;
  return new FiltersClass(listingType, _objectSpread(_objectSpread({}, filters), {}, {
    localities: locationFromQueryObject(divisionId, filters.localities)
  }));
};
export default Filters;
export { toLocality };